import { render } from "./HeaderBeranda.vue?vue&type=template&id=3f36df6e"
import script from "./HeaderBeranda.vue?vue&type=script&lang=js"
export * from "./HeaderBeranda.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__